import { useState, useMemo } from 'react';
import Slider from 'react-slick';
import { Modal } from 'react-bootstrap';
import { IoClose } from "react-icons/io5";

const testimonialsData = [
    {
        id: 1,
        img: 'assets/images/testimony/johannes.jpeg',
        text: 'Belajar General English di NIEC begitu menyenangkan dan juga bertemu dengan teman teman sekelas di IHMS memberikan perubahan yang cukup besar tentunya baik dalam vocabulary ada beberapa kata yang tadinya belum tau jadi tau ada begitu banyak yang dipelajari juga kemudian Teacher nya juga cukup menyenangkan santai akan tetapi materi yang disampaikan cukup jelas tentunya cukup mudah dipahami dan meningkatkan kepercayaan diri sedikit lebih baik dibandingkan sebelumnya.',
        name: 'Johannes',
        course: 'General English Class',
    },
    {
        id: 2,
        img: 'assets/images/testimony/regina.jpeg',
        text: 'Belajar di NIEC benar-benar memberikan perubahan besar untuk kemampuan bahasa Inggris saya. Teacher-nya sangat luar biasa, cara mengajarnya mudah dipahami dan membuat saya lebih percaya diri dalam berbahasa Inggris.Saya juga merasa sangat terbantu dengan fleksibilitas jadwal kelas yang bisa disesuaikan dengan aktivitas kerja dan kuliah saya, jadi tetap bisa belajar tanpa mengganggu rutinitas harian.',
        name: 'Regina',
        course: 'General English Private Class',
    },
    {
        id: 3,
        img: 'assets/images/testimony/mara.jpeg',
        text: 'The classes were very effective with lots of speaking practice. I learned how to speak English with the right grammar and gained real confidence.',
        name: 'Mara',
        course: 'General English Class',
    },
    {
        id: 4,
        img: 'assets/images/testimony/adam.jpeg',
        text: 'Terima kasih NIEC Indonesia karena telah membantu saya untuk belajar mengenai IELTS Test di NIEC English Course dengan mengajarkan saya dengan guru yang terbaik, aktif memberikan latihan soal, ramah dan berperan penting untuk perkembangan kemampuan IELTS Test saya. Dan sampai saat ini saya mengucapkan terima kasih kepada NIEC Indonesia karena saya sudah berhasil untuk meraih hasil IELTS Test yang terbaik di score 6.5 dan kenaikan skor yang signifikan di skill listening and writing.',
        name: 'Adam Dhamar',
        course: 'IELTS Preparation Private Class',
    },
    {
        id: 5,
        img: 'assets/images/testimony/nadine.jpeg',
        text: 'Selama belajar di NIEC, khususnya di kelas General English, saya mendapatkan pengalaman yang sangat menyenangkan dan bermanfaat. Saya memilih NIEC karena reputasinya yang baik dlm membantu meningkatkan kemampuan bahasa inggris utk studi ke luar negeri. Suasana kelasnya nyaman dan interaktif, sehingga saya merasa lebih percaya diri. Kemampuan saya meningkat terutama di Writing dan Reading, di mana saya lebih baik dlm Menyusun tulisan dan memahami teks serta didukung oleh peningkatan vocabulary dan grammar. Kelas ini juga dpt membantu sebagai dasar persiapan IELTS, dan saya berhasil meraih skor 6.0 yang menunjukkan peningkatan. Belajar Bersama Mr. Ben juga sangat menyenangkan karena suasana belajar santai dan cara mengajar yang tidak membosankan. Konsultan saya, Kak Ani, juga sangat membantu dengan penjelasan yang jelas, terstruktur, serta sikap yang ramah and responsif. Saya sangat berterima kasih kepada NIEC atas dukungan dan pengalaman belajar yang berharga, dan saya juga akan dengan senang hati merekomendasikan NIEC kepada teman teman saya.',
        name: 'Nadine Sisilia',
        course: 'General English Private Class',
    },
    {
        id: 6,
        img: 'assets/images/testimony/catur.jpeg',
        text: 'The teachers here are incredibly friendly and supportive. They don’t just teach—they truly encourage every student to speak English with confidence. The class atmosphere is fun, interactive, and motivating, which makes learning feel easy and enjoyable.',
        name: 'Catur',
        course: 'General English Class',
    },
    {
        id: 7,
        img: 'assets/images/testimony/dede.jpeg',
        text: 'Kelasnya sangat nyaman, dan gurunya baik serta sabar selama proses belajar. Untuk konsultannya, Kak Anii juga sangat membantu, membimbing saya dari awal sampai visa granted. Saya merasakan peningkatan yang signifikan terutama di skill writing, dari band 4.5 menjadi 6.0 di real test IELTS. Semoga cerita saya bisa menginspirasi teman-teman untuk mulai belajar bahasa Inggris lebih awal dan mempersiapkan studi ke luar negeri.',
        name: 'Dede',
        course: 'IELTS Preparation Class',
    },    
];

const StudentTestimonial = () => {
    
    const shuffledTestimonials = useMemo(() => {
        return [...testimonialsData].sort(() => Math.random() - 0.5);
    }, []);

    const [selectedTestimonial, setSelectedTestimonial] = useState(null);

    const settings = {
        arrows: false,
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 2,
        autoplay: true,
        swipeToSlide: true,
        autoplaySpeed: 3000,
        responsive: [
            {
                breakpoint: 1200,
                settings: { slidesToShow: 3 },
            },
            {
                breakpoint: 992,
                settings: { slidesToShow: 2 },
            },
            {
                breakpoint: 576,
                settings: { slidesToShow: 1 },
            },
        ],
    };

    return (
        <section className="testimonial-section section-padding">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-xl-8">
                        <div className="section-heading text-center mb-50">
                            <h2 className="font-lg">Apa Kata Mereka</h2>
                            <p className="mt-2">
                                Keberhasilan siswa kami adalah prioritas utama. Lihat bagaimana NIEC membantu mereka mencapai mimpi.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="testimonial-slider">
                    <Slider {...settings}>
                        {shuffledTestimonials.map((data) => {
                            return (
                                <div key={data.id} className='px-2'>
                                    <div className="testimonial-card p-4">
                                        <div className="quote-icon mb-3">
                                            <i className="fa fa-quote-left"></i>
                                        </div>
                                        <div className="testimonial-text collapsed">
                                            “{data.text}”
                                        </div>
                                        {data.text.length > 150 && (
                                            <a
                                                className="toggle-btn"
                                                onClick={() => setSelectedTestimonial(data)}
                                            >
                                                Baca Selengkapnya
                                            </a>
                                        )}
                                        <div className="client-info d-flex align-items-center mt-auto pt-3">
                                            <div className="client-img me-3">
                                                <img
                                                    src={data.img}
                                                    alt={data.name}
                                                    className="rounded-circle"
                                                />
                                            </div>
                                            <div className="testimonial-author">
                                                <h4 className="mb-0">{data.name}</h4>
                                                <span className="meta">{data.course}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        })}
                    </Slider>
                </div>
            </div>
            <Modal
                show={!!selectedTestimonial}
                onHide={() => setSelectedTestimonial(null)}
                centered
                size="lg"
                backdrop="true"
                keyboard
            >
                <Modal.Header>
                    <Modal.Title>
                    {selectedTestimonial && (
                        <div>
                            <h6 className="mb-0">{selectedTestimonial.name}</h6>
                            <h6 className="text-muted">
                                {selectedTestimonial.course}
                            </h6>
                        </div>
                    )}
                    </Modal.Title>
                    <a className='custom-close' onClick={() => setSelectedTestimonial(null)}>
                        <IoClose size={24} />
                    </a>
                </Modal.Header>

                <Modal.Body>
                    {selectedTestimonial && (
                        <>
                            <p className="mb-4">
                                “{selectedTestimonial.text}”
                            </p>
                        </>
                    )}
                </Modal.Body>
            </Modal>
        </section>
    );
};

export default StudentTestimonial;
